function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './swiper-carousel.component.scss';
import template from './swiper-carousel.html';

export { SwiperSlideComponent } from "./swiper-slide/swiper-slide.component";

export var SwiperCarouselComponent = {
  template: template,
  styles: styles,
  transclude: {
    prev: '?uiSwiperCarouselPrev',
    next: '?uiSwiperCarouselNext' },

  bindings: {
    optionNavigation: '<?navigation',
    optionPagination: '<?withPagination',
    optionScrollbar: '<?scrollbar',
    optionKeyboard: '<?keyboard',
    swiperOptions: '<swiperOptions',
    effectFlip: '<flip',
    currentSlide: '<?',
    activateSlideByClick: '<?',
    _onChangeSlide: '&onChangeSlide',
    _getSwiperInstance: '&getSwiperInstance' },

  controller: /*#__PURE__*/function () {SwiperCarouselComponentController.$inject = ["$element", "$scope", "$timeout", "Swiper"];
    function SwiperCarouselComponentController($element, $scope, $timeout, Swiper) {
      "ngInject";_classCallCheck(this, SwiperCarouselComponentController);
      console.log(this);
      this.Swiper = Swiper;
      this.$element = $element;
      this.$scope = $scope;
      this.$timeout = $timeout;

      this.swiperInstance = null;
      this.currentSlide = 0;
      this.swiperOptions = {};
      this.activateSlideByClick = false;
    }_createClass(SwiperCarouselComponentController, [{ key: "getSwiperParams", value: function getSwiperParams()























      {var overwrites = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var result = _objectSpread({},
        this.swiperDefaults,
        this.optionNavigation ? {
          navigation: {
            nextEl: this.$next,
            prevEl: this.$prev } } :

        {},
        this.optionPagination ? {
          pagination: {
            el: this.$pagination,
            clickable: true,
            type: 'bullets' } } :

        {},
        this.optionScrollbar ? {
          scrollbar: {
            el: this.$scrollbar,
            draggable: true,
            hide: true } } :

        {},
        this.optionKeyboard ? {
          keyboard: {
            enabled: true,
            onlyInViewport: true } } :

        {},
        this.effectFlip ? {
          effect: 'flip' } :
        {},
        this.swiperOptions,
        overwrites, {
          initialSlide: this.currentSlide,
          init: false });


        //some rules here
        if (result.loop && result.slidesPerView === 'auto') {
          console.warn("you can not use \"loop:true\" and \"slidesPerView:'auto'\" together");
          result.loop = false;
        }

        if (result.loop) {
          result.initialSlide += 1;
        }

        console.log(result);
        return result;
      } }, { key: "$onChanges", value: function $onChanges(





      changes) {var
        swiperOptions = changes.swiperOptions,currentSlide = changes.currentSlide;

        var needReinit = [
        'optionNavigation',
        'optionPagination',
        'optionScrollbar',
        'optionKeyboard',
        'effectFlip',
        'swiperOptions'].
        some(function (key) {return !!changes[key];});

        if (swiperOptions) {
          this.swiperOptions = angular.copy(swiperOptions.currentValue);
        }

        if (needReinit && this.isInitialised) {
          this.reinitSwiperInstance();
        }

        if (currentSlide && this.isInitialised) {
          this.setSlide(currentSlide.currentValue);

          /* this is important for preserve index while slides render
                                                     * and handles by Mutation Observer of Swiper */
          this.swiperInstance.activeIndex = currentSlide.currentValue;
        }
      } }, { key: "$onInit", value: function $onInit()

      {
        this.$element.addClass(styles["is-loading"]);
      } }, { key: "$postLink", value: function $postLink()

      {var _this = this;
        this.$container = this.$element.find(".swiper-container").eq(0);
        this.$slidesContainer = this.$container.find(".swiper-wrapper").eq(0);
        this.$pagination = this.$element.find(".swiper-pagination").eq(0);
        this.$prev = this.$element.find(".swiper-button-prev").eq(0);
        this.$next = this.$element.find(".swiper-button-next").eq(0);
        this.$scrollbar = this.$element.find(".swiper-scrollbar").eq(0);
        this.swiperInstance = this.createSwiperInstance();

        this.$slidesContainer.on('click', '> *', this.onSlideClick.bind(this));

        this.$timeout(function () {// wait for angular's render
          _this.swiperInstance.init();
          _this.$element.removeClass(styles["is-loading"]);
        });
      } }, { key: "$onDestroy", value: function $onDestroy()

      {var _this2 = this;
        if (this.swiperInstance) {
          // timeout because of strange problem...
          setTimeout(function () {return _this2.swiperInstance.destroy();}, 500);
        }
      } }, { key: "onSlideClick", value: function onSlideClick(

      e) {
        if (this.activateSlideByClick) {
          this.setSlide(angular.element(e.currentTarget).index());
        }
      } }, { key: "createSwiperInstance", value: function createSwiperInstance(

      container) {var _this3 = this;var overwrites = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var instance = new this.Swiper(
        this.$container,
        this.getSwiperParams(overwrites));

        instance.on('slideChange', function () {
          _this3.$scope.$applyAsync(function () {
            _this3._onChangeSlide({ index: instance.activeIndex });
          });
        });
        this._getSwiperInstance({ instance: instance });
        return instance;
      }

      /**
         * Set slide in range between min and max of available.
         * @param index {number}
         * @returns {boolean} if true - slide was set successfully set
         */ }, { key: "setSlide", value: function setSlide()
      {var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        if (!this.swiperInstance) return false;
        if (!this.swiperInstance.slides || !this.swiperInstance.slides.length) return false;
        // Swiper adds copies of first and last slide in loop mode,
        // we do not need them here
        var slidesLength = this.swiperInstance.params.loop ?
        this.swiperInstance.slides.length - 2 :
        this.swiperInstance.slides.length;

        index = function () {
          if (index > slidesLength - 1) {
            return slidesLength - 1;
          } else if (index < 0) {
            return 0;
          } else return index;
        }();

        var slideSuccess = this.swiperInstance.slideTo(
        this.swiperInstance.params.loop ? index + 1 : index);

        return slideSuccess;
      } }, { key: "reinitSwiperInstance", value: function reinitSwiperInstance()

      {var prevSwiper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.swiperInstance;
        console.warn('[slider] reinit');
        if (!prevSwiper) return false;

        var currentSlide = prevSwiper.realIndex || prevSwiper.activeIndex;
        var components = Object.values(prevSwiper).
        filter(function (com) {return !!com &&
          typeof com.destroy === 'function';});


        components.forEach(function (com) {return com.destroy();});var
        removeInstance = true,removeStyles = false;
        prevSwiper.destroy(removeInstance, removeStyles);

        this.swiperInstance = this.createSwiperInstance({
          initialSlide: currentSlide });

        this.swiperInstance.init();
      } }, { key: "swiperDefaults", get: function get() {return { // Optional parameters
          loop: false, initialSlide: 0, observer: true, slidesPerView: 'auto', centeredSlides: true, spaceBetween: 21, nested: true, threshold: 40, roundLengths: true, setWrapperSize: true, breakpoints: { 1199: { spaceBetween: 12, threshold: 10 } } };} }, { key: "isInitialised", get: function get() {return this.swiperInstance && this.swiperInstance.initialized;} }]);return SwiperCarouselComponentController;}() };




if (module.hot) module.hot.accept('./swiper-carousel.component.scss');